module.exports = __webpack_public_path__ + "c98bd09a25d2f544f40a0a3a8ea21fff.fbx";